import React, { Fragment, useEffect } from "react";
import { Form, Input, Button, DatePicker, message, InputNumber } from "antd";
import {
  createPastProjects,
  updatePastProjects,
} from "../../../../../services/vendorProfile.services";
import moment from "moment";
import DrawerWizz from "../../../../../reusable/DrawerWizz";
import { maxNumValidation } from "../../../../../config/validation.config";

const PastProjectsModal = ({
  title,
  setVisible,
  vendorId,
  editTable,
  refresh,
}) => {
  const [form] = Form.useForm();

  //Disable Date greater than today
  function disabledDate(current) {
    return current && current > moment().endOf("day");
  }

  useEffect(() => {
    if (editTable.status === "update") {
      setFormFieldValues(editTable);
    }
  }, [editTable]);

  function setFormFieldValues(data) {
    form.setFieldsValue({
      ...data,
      date_completed: moment(data.date_completed),
    });
  }

  const handleCancel = () => {
    setVisible(false);
    refresh();
  };

  const onFinish = (values) => {
    if (editTable.status === "update") {
      const formData = {
        ...values,
        vendor_id: vendorId,
        id: editTable.id,
        date_completed: moment(values.date_completed).format("YYYY-MM-DD"),
      };

      updatePastProjects(formData)
        .then((response) => {
          message.success(response.data.message);
          handleCancel();
        })
        .catch((error) => console.error(error));
    } else {
      const formData = {
        ...values,
        vendor_id: vendorId,
        date_completed: moment(values.date_completed).format("YYYY-MM-DD"),
      };

      createPastProjects(formData)
        .then((response) => {
          message.success(response.data.message);
          handleCancel();
        })
        .catch((error) => console.error(error));
    }
  };

  return (
    <Fragment>
      <DrawerWizz
        title={title}
        handleCancel={handleCancel}
        content={
          <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
            scrollToFirstError
          >
            <Form.Item
              name="name_of_project"
              label="Name of the Project"
              rules={[
                {
                  required: true,
                  message: "Please input project name!",
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>
            <Form.Item
              name="project_key_contact"
              label="Project Key Contact"
              rules={[
                {
                  required: true,
                  message: "Please input project key contact!",
                },
              ]}
            >
              <Input placeholder="Project Key Contact" />
            </Form.Item>
            <Form.Item
              name="amount_of_contract"
              label="Amount Of Contract"
              rules={[
                {
                  required: true,
                  message: "Please input amount of contract!",
                },
              ]}
            >
              <InputNumber
                placeholder="Amount Of Contract"
                step="0.01"
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                style={{ minWidth: "280px" }}
              />
            </Form.Item>
            <Form.Item
              name="scope"
              label="Project scope"
              rules={[
                {
                  required: true,
                  message: "Please input project scope!",
                },
              ]}
            >
              <Input placeholder="Project scope" />
            </Form.Item>
            <Form.Item
              name="percent_subcontracted"
              label="Percent Subcontracted"
              rules={maxNumValidation}
            >
              <InputNumber
                style={{ minWidth: "280px" }}
                placeholder="Percent Subcontracted"
                step="0.01"
                max={100}
              />
            </Form.Item>
            <Form.Item
              name="date_completed"
              label="Date Completed"
              rules={[
                {
                  required: true,
                  message: "Please input date!",
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                placeholder="Date"
                size="large"
                disabledDate={disabledDate}
                style={{ minWidth: "280px" }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        }
      />
    </Fragment>
  );
};

export default PastProjectsModal;
